import * as React from "react";
import { useTranslation } from 'react-i18next';

import Layout from "../components/layout/layout";
import GeneralTerms from "../components/privacy_policies/general_terms";
import Seo from "../components/seo";

const PolitiqueDeCookies = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('terms_of_use')}
        description={t('terms_of_use')}
      />
      <Layout>
        <GeneralTerms />
      </Layout>
    </>
  )
}

export default PolitiqueDeCookies;
